<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
//import axios from "axios";
/**
 * People-product component
 */
export default {
  page: {
    title: "Add Project",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
    DatePicker,
  },
  data() {
    return {
      title: "People",
      filterValue: null,
      range: null,
    }
  },
  methods: {
  },
  created() {
  },
  computed: {
    searchevents: function(){
      var result = this.people;
      if (!this.filterValue)
        return result;
        
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) || event.email.toLowerCase().includes(filterValue) || event.designation.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.projects.list.people')" />
    <div class="row mb-1">
      <div class="col-md-3">
        <div class="search-box mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.projects.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      
      </div>
      <div class="col-md-4" style="margin-top : -8px;">
      <div class="row">
        <div class="col-md-4">
        <b-dropdown id="dropdown-dropleft"  dropleft text="Drop-Left" variant="outline-secondary" class="m-2" checkbox-menu allow-focus>
            <template #button-content>
              <i class="bx bx-filter-alt ps-2 pe-2 font-size-14"></i><span class="pe-4">Filters</span>
            </template>
            <b-dropdown-form inline>
              <b-col md="12">
                <b-form-checkbox
                  class="form-check m-2"
                >
                  On Time
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Delayed
                </b-form-checkbox>
                <b-form-checkbox
                  class="form-check ms-2"
                >
                  Exceeded Budget
                </b-form-checkbox>
                </b-col>
                <b-col md="10">
              <b-form-select
                class="form-select m-2"
              >
                <b-form-select-option :value="-1"
                  >Hours...</b-form-select-option
                >
                <b-form-select-option value="0"
                  >00</b-form-select-option
                >
                <b-form-select-option value="1"
                  >01</b-form-select-option
                >
              </b-form-select>
              <b-form-select
                class="form-select m-2"
              >
                <b-form-select-option :value="-1"
                  >Hours...</b-form-select-option
                >
                <b-form-select-option value="0"
                  >00</b-form-select-option
                >
                <b-form-select-option value="1"
                  >01</b-form-select-option
                >
              </b-form-select>
              </b-col>
            </b-dropdown-form>
        </b-dropdown>
        </div>
        <div class="col-md-4">
          <b-dropdown id="dropdown-dropleft" dropleft text="Drop-Left" variant="outline-primary" class="m-2" checkbox-menu allow-focus>
            <template #button-content>
              <span class="pe-4">Add Columns</span>
            </template>
            <b-dropdown-form>
              <b-form-checkbox
                  class="form-check mt-2 ms-2"
                >
                  Absent Days
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Late Days
                </b-form-checkbox>
                <b-form-checkbox
                  class="form-check ms-2"
                >
                  Delayed Projects
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Earnings
                </b-form-checkbox><b-form-checkbox
                  class="form-check ms-2"
                >
                  Score
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Rule
                </b-form-checkbox>
            </b-dropdown-form>
        </b-dropdown>
        </div>
      </div>
      </div>
      <div class="col-md-2" style="margin-top : -8px;">
      </div>
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
        <date-picker ref="datePicker" placeholder="Select Date Range" v-model="range" range lang="en" confirm></date-picker></div>
        <div class="col-md-1" style="margin-left : -8px;">
        <button class="btn btn-secondary"><i class="bx bxs-download"></i></button></div>
        </div>
      </div>
    </div>
      
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="is-loading">
            <div class="preloader-component" v-show="false">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <div class="card-body" style="height: calc(100vh - 280px)">
            <div class="is-loading">
              <div class="preloader-component" v-show="false">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
                <simplebar style="max-height: calc(100vh - 290px)">
                  <div class="table-responsive">
                    <table
                      class="table align-middle table-nowrap table-hovers"
                    >
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Member</th>
                          <th scope="col">Present Days</th>
                          <th scope="col">Projects</th>
                          <th scope="col">Working Time</th>
                          <th scope="col">Idle Time</th>
                          <th scope="col">Activity</th>
                          <th scope="col">Productivity</th>
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
      </div> 
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>